import { IsNotEmpty, IsEmail } from 'class-validator';

export class ProfileVerificationCodeDTO {

    @IsNotEmpty()
    @IsEmail()
    email: string;

}
